export default __webpack_public_path__ + "static/media/timelineUpdate.de762163.svg";